import React, { useState, useRef } from "react";
import { Box, Grow, Portal } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import notAllowedIcon from "../../assets/images/icons/not-allowed.svg";
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  lockOverlay: {
    cursor: `url(${notAllowedIcon}), not-allowed`,
    "& span": {
      display: "none"
    },
    "&:hover": {
      "& span": {
        display: "block"
      }
    }
  },
  tooltip: {
    display: "block",
    position: "fixed",
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    margin: theme.spacing(1, 0),
    width: 280,
    zIndex: 1500,
    pointerEvents: "none",
    fontSize: "0.93rem",
    lineHeight: "1.07rem",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    borderRadius: 2,
    boxShadow:
      "0px 0px 2px rgba(0, 0, 0, 0.16), 0px 4px 12px rgba(0, 0, 0, 0.25)"
  },
  tooltipBlackMode: {
      color: "white",
      backgroundColor: "#606165"
  }
}));

export default function LightTooltip({
  text,
  top = 0,
  bottom = 0,
  fromRight = false,
  blackMode = false
}) {
  const classes = useStyles();
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const tooltipRef = useRef();
  return (
    <Box
      position="absolute"
      top={top}
      bottom={bottom}
      left={0}
      right={0}
      className={classes.lockOverlay}
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
      onMouseMove={e => {
        var x = e.clientX + 35,
          y = e.clientY - 5;
        if (tooltipRef.current) {
          if (fromRight) {
            tooltipRef.current.style.right =
              Math.max(window.innerWidth - x - 280, 16) + "px";
            tooltipRef.current.style.top = y + "px";
          } else {
            tooltipRef.current.style.left = x + "px";
            tooltipRef.current.style.top = y + "px";
          }
        }
      }}
    >
      <Portal>
        <Grow mountOnEnter unmountOnExit in={tooltipVisible}>
          <span className={clsx(classes.tooltip, blackMode && classes.tooltipBlackMode)} ref={tooltipRef} >
            {text}
          </span>
        </Grow>
      </Portal>
    </Box>
  );
}
